import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import GreyCard from "../../components/GreyCard/GreyCard";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {Button, Col, ProgressBar} from "react-bootstrap";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Выплата заработной платы</h1>
            </StartStep>

            <GreyCard>
                <p>
                    При отсутствии банковского счета, к которому привязана карта МИР, НИУ ВШЭ выпустит Вам банковскую
                    карту в рамках зарплатного проекта. Для этого Вам необходимо направить на эл.адрес&nbsp;
                    <a href="mailto:PayrollDepartment@hse.ru">PayrollDepartment@hse.ru</a>&nbsp;заполненную анкету на выпуск
                    карты МИР ВТБ и скан/фото основного разворота
                    паспорта (страницы 2,3).
                </p>
                <br/>
                <p><a
                    href="https://fd.hse.ru/data/2021/08/09/1425006282/%D0%97%D0%B0%D1%8F%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5 %D0%BD%D0%B0 %D0%B2%D1%8B%D0%BF%D1%83%D1%81%D0%BA %D0%BA%D0%B0%D1%80%D1%82%D1%8B.docx">Заявление
                    на выпуск карты </a></p>
                <br/>
                <p>График выплаты заработной платы</p>
                <br/>
                <p> В соответствии со статьей 136 Трудового кодекса РФ заработная плата выплачивается не реже чем каждые
                    полмесяца.
                </p>
                <br/>
                <p>
                    Заработная плата работника НИУ ВШЭ выплачивается в следующие дни календарного месяца:
                </p>
                <ul>
                    <li>за первую половину месяца 25 числа текущего месяца;</li>
                    <li>за вторую половину месяца 10 числа следующего месяца.</li>
                </ul>
                <br/>
                <p>
                    В соответствии с Указанием от 11 марта 2014 г.N 3210-У Центрального Банка Российской Федерации
                    период выплаты заработной платы составляет 3 дня.
                </p>
                <br/>
                <p>
                    При совпадении дня выплаты с выходным или нерабочим праздничным днем, выплата заработной платы
                    производится накануне этого дня (<a
                    href="consultantplus://offline/ref=119FD3A81269DEB52D35FC200FF4E2DBAB7A851CC180A351F06995B1C65247285A8416932B711DFBrEj8K">ч.
                    8 ст. 136</a> ТК РФ).
                </p>
                <br/>
                <p><a href="https://fd.hse.ru/">Сервисы финансовой дирекции</a></p>
            </GreyCard>

            <br/><br/>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step6">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{ textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={63}/>
                        <span>Шаг 7 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step8">Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;